import * as React from 'react';
import { VerticalTabs } from 'wix-style-react';
import { CategoriesData } from './categories-data';
import { DataHooks } from '@src/constants/data-hooks';
import { translate, InjectedTranslateProps } from 'react-i18next';

interface Props extends InjectedTranslateProps {
  selectedTab: number;
  setTab(tab: number): void;
}

export const CategoryTabs = translate()(({ t, selectedTab, setTab }: Props) => (
  <VerticalTabs dataHook={DataHooks.AdvancedCategoriesTabs} onChange={setTab} activeTabId={selectedTab}>
    {CategoriesData.map((category, idx) => (
      <VerticalTabs.TabItem
        dataHook={DataHooks.AdvancedCategoriesTab + category.headlineKey}
        key={category.headlineKey}
        id={idx + 1}
      >
        {t(category.title)}
      </VerticalTabs.TabItem>
    ))}
  </VerticalTabs>
));
